
import { CircularProgress, Grid, Typography } from '@material-ui/core';
import { Auth } from 'aws-amplify';
import axios from 'axios';
import React, { useRef } from 'react';
import { connect } from 'react-redux';
import { Branding } from '../../branding';
import { signOut } from '../../common/service';
import { eraseCookie } from '../../components/LandingPage/helpers/cookieHelper';

const mapStateToProps = (state) => {
    return {
        user: state.app.user,
        lang: state.app.lang,
    }
}

const LogoutPage = (props) => {

    var redirectInfo = localStorage.getItem('redirectInfo');
    let queryStringParams = new URLSearchParams(window.location.search);
    const isLogoutInitiated = useRef(false);

    React.useEffect(() => {

        var initiateLogout = async () => {

            eraseCookie("id_token");
            eraseCookie("access_token");
            eraseCookie("refresh_token");
            eraseCookie("discovery_auth_token");

            // Accept requests according to https://docs.aws.amazon.com/cognito/latest/developerguide/logout-endpoint.html
            let clientID = queryStringParams.get('client_id');
            let logoutURI = queryStringParams.get('logout_uri');
            let redirectURI = queryStringParams.get('redirect_uri');
            let responseType = queryStringParams.get('response_type');
            let codeChallenge = queryStringParams.get('code_challenge');
            let codeChallengeMethod = queryStringParams.get('code_challenge_method');

            // Store the redirect info in local storage before calling the Cognito Hosted UI to logout
            var redirectObject;
            if (clientID && logoutURI) { // For redirect to client
                redirectObject = { 'clientID': clientID, 'logoutURI': logoutURI };
            }
            else if (responseType === "id_token" && clientID && redirectURI) { // For implicit flow
                redirectObject = { 'clientID': clientID, 'responseType': responseType, 'redirectURI': redirectURI };
            }
            else if (responseType === "code" && clientID && redirectURI && codeChallenge && codeChallengeMethod) { // For PKCE flow
                redirectObject = { 'clientID': clientID, 'responseType': responseType, 'redirectURI': redirectURI, 'codeChallenge': codeChallenge, 'codeChallengeMethod': codeChallengeMethod };
            }
            else {
                redirectObject = { 'redirect': 'broker' };
            }

            localStorage.setItem('redirectInfo', JSON.stringify(redirectObject));
            localStorage.removeItem('client-id');

            try {
                await Auth.signOut();
            } catch (error) {
                console.log(error)
            }

            try {
                // if logout gets redirectUrl
              if (queryStringParams.get('redirectUrl')) {
                  sessionStorage.removeItem("logoutRedirectUrl");
                  sessionStorage.setItem('redirectUrl', queryStringParams.get('redirectUrl'))
                  localStorage.removeItem('redirectInfo');
                  await signOut();
                  return;
              }
              // if logout gets logoutRedirectUrl
              else if (queryStringParams.get('logoutRedirectUrl')) {
                  sessionStorage.removeItem("logoutRedirectUrl");
                  sessionStorage.setItem('redirectUrl', queryStringParams.get('logoutRedirectUrl'))
                  localStorage.removeItem('redirectInfo');
                  await signOut();
                  return;
              }
              else if (sessionStorage.getItem("redirectUrl")){
                  window.location = sessionStorage.getItem("redirectUrl")
                  return;
              }
          } catch (error) {
              window.location = "/";
              return;
          }

            window.location.reload(); // Reload the page to handle the client redirect

        }

        var fn = async () => {
            if (redirectInfo) { // For handling a redirect back from the Cognito Hosted UI
                localStorage.removeItem('redirectInfo');
                var rdJSON = JSON.parse(redirectInfo);
                if (rdJSON['clientID'] && rdJSON['logoutURI']) { // Redirect back to client
                    axios.get('/verifyClient', {
                        params: {
                            client_id: rdJSON['clientID'],
                            logout_uri: rdJSON['logoutURI']
                        }
                    }).then(response => {
                        if (response.status === 200) {
                            window.location.assign(rdJSON['logoutURI']);
                        }
                    }).catch(error => {
                        console.error(error.response)
                        window.location.href = '/';
                    });
                }
                else if (rdJSON['responseType'] === "id_token" && rdJSON['clientID'] && rdJSON['redirectURI']) { // Call authorize endpoint to start implicit flow
                    let authorizeEndpointPath = '/oauth2/authorize/?response_type=' + rdJSON['responseType']
                        + "&client_id=" + rdJSON['clientID'] + "&redirect_uri=" + rdJSON['redirectURI'];
                    window.location.href = authorizeEndpointPath;
                }
                else if (rdJSON['responseType'] && rdJSON['clientID'] && rdJSON['redirectURI'] && rdJSON['codeChallenge'] && rdJSON['codeChallengeMethod']) { // Call authorize endpoint to start PKCE flow
                    let authorizeEndpointPath = '/oauth2/authorize/?response_type=' + rdJSON['responseType'] + "&client_id=" + rdJSON['clientID']
                        + "&redirect_uri=" + rdJSON['redirectURI'] + "&code_challenge=" + rdJSON['codeChallenge']
                        + "&code_challenge_method=" + rdJSON['codeChallengeMethod'];
                    window.location.href = authorizeEndpointPath;
                }
                else { // Default to redirecting to the broker login page
                    let redirectUrl = queryStringParams.get('logoutRedirectUrl') || sessionStorage.getItem("logoutRedirectUrl");
                    sessionStorage.removeItem("logoutRedirectUrl")
                    let relativeRedirectUrl = null;
                    if (sessionStorage.getItem("isResetPasswordFlow")) {
                        sessionStorage.removeItem("isResetPasswordFlow");
                        relativeRedirectUrl = "/resetPassword";
                    }
                    signOut(redirectUrl, relativeRedirectUrl);
                }
            }
            else {
                await initiateLogout();
            }
        }

        if (!isLogoutInitiated.current)
            fn();

        isLogoutInitiated.current = true;

    }, []);

    return <Grid container
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{ marginTop: "20%" }}>
        <CircularProgress variant='indeterminate' thickness={3} size={"3em"} />
        {
            sessionStorage.getItem("link_acc_token") ? <></> :
                <Typography style={{
                    marginBottom: "2em",
                    fontWeight: 'bold',
                    marginTop: "2em",
                    fontSize: "12px",
                    color: Branding.primary
                }}> Logging out. Please wait… </Typography>
        }

    </Grid>

}

export default connect(mapStateToProps, {})(LogoutPage);
//export default Logout;
